module.exports = __webpack_public_path__ + "img/creditcard.00da5cae.svg";